/**
* Created by kongwm.kong on 2017/7/26.
*/
<template>
    <div>
        <modal name="submitOk" :width="580" :height="'auto'" @closed="hide">
            <div class="vue-modal-wrap">
                <div class="modal-title">提示信息<span @click="hide">x</span></div>
                <div class="modal-bd" v-if="!isSaveFlag">
                    <h1>上传成功</h1>
                    <div class="ps">
                        我们将于1个工作日内审核完毕，如有任何意见或者细节疑问反馈，请致电：0755-29330548（陈小姐）
                        或发送邮件至：data@jfz.com进行对接；
                    </div>
                </div>
                <div class="modal-bd" v-else >
                    <h1>保存成功</h1>
                    <div class="ps">
                        保存后，信息存在本地可随时更改，未提交审核
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    export default {
        props:{
          isSave:{
              type: Boolean,
              default: false
          }
        },
        computed:{
            isSaveFlag(){
                return this.isSave;
            }
        },
        data(){
            return {

            }
        },
        methods : {
            show(){
                this.$modal.show('submitOk');
            },
            hide(){
                this.$modal.hide('submitOk');
                this.$emit('closeModal');
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .vue-modal-wrap{
        @include bgff;
        width:580px;
        .modal-bd{
            padding: 40px 50px ;
            h1{
                color:$btn_408;
                font-size: 22px;
                font-weight: bold;
                text-align: center;
                margin-bottom:15px;
            }
            .ps{
                color:$c_666;
                font-size:16px;
                line-height:24px;
                margin-bottom:40px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/modal/submitOk.vue